function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10,9 C9.44771525,9 9,9.44771525 9,10 L9,19 C9,19.5522847 9.44771525,20 10,20 L19,20 C19.5522847,20 20,19.5522847 20,19 L20,10 C20,9.44771525 19.5522847,9 19,9 L10,9 Z M19,7 C20.6568542,7 22,8.34314575 22,10 L22,19 C22,20.6568542 20.6568542,22 19,22 L10,22 C8.34314575,22 7,20.6568542 7,19 L7,10 C7,8.34314575 8.34314575,7 10,7 L19,7 Z M12,0 C13.6568542,0 15,1.34314575 15,3 L15,3 L15,4 C15,4.55228475 14.5522847,5 14,5 C13.4477153,5 13,4.55228475 13,4 L13,4 L13,3 C13,2.44771525 12.5522847,2 12,2 L12,2 L3,2 C2.44771525,2 2,2.44771525 2,3 L2,3 L2,12 C2,12.5522847 2.44771525,13 3,13 L3,13 L4,13 C4.55228475,13 5,13.4477153 5,14 C5,14.5522847 4.55228475,15 4,15 L4,15 L3,15 C1.34314575,15 0,13.6568542 0,12 L0,12 L0,3 C0,1.34314575 1.34314575,0 3,0 L3,0 Z",
  id: "path-1"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Main-Mobile",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "2FA---Google---Register",
  transform: "translate(-194.000000, -475.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 414,
  height: 896
}), /*#__PURE__*/React.createElement("g", {
  id: "copy",
  transform: "translate(195.000000, 476.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Combined-Shape",
  fill: "#003246",
  xlinkHref: "#path-1"
}))));

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.3a1f0438.svg";
export { ForwardRef as ReactComponent };